import React from "react";

export const DEMAND_SAFETY = {
  PASS: { bg: "bg-lr-olive/15", text: "text-lr-olive", label: "PASS" },
  BLOCK: { bg: "bg-lr-rose/20", text: "text-[#8f4a49]", label: "BLOCK" },
  INVESTIGATE: { bg: "bg-lr-clay/15", text: "text-lr-clay", label: "INVESTIGATE" },
};

export function StatusPill({ status }) {
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-[3px] text-xs font-medium bg-lr-olive/12 text-lr-olive border border-lr-olive/20">
      {status || "Not set"}
    </span>
  );
}

export function ContactFlag({ status }) {
  if (status === "do_not_contact")
    return <span data-testid="contact-flag" className="inline-flex items-center px-2 py-0.5 rounded-[3px] text-xs font-semibold bg-lr-rose/20 text-[#8f4a49]">Do not contact</span>;
  if (status === "only_if_they_contact")
    return <span data-testid="contact-flag" className="inline-flex items-center px-2 py-0.5 rounded-[3px] text-xs font-medium bg-lr-clay/15 text-lr-clay">Contact only if they reach out</span>;
  return null;
}

export function ArchivedBadge() {
  return <span className="inline-flex items-center px-2 py-0.5 rounded-[3px] text-xs bg-lr-leather/15 text-lr-leather">Archived</span>;
}

// Operational flag: Blueprint finished (Ready) but not yet sent to the customer.
// Derived purely from business.status (flips to "Blueprint Delivered" on Mark Delivered).
export function UndeliveredFlag({ status }) {
  if (status !== "Blueprint Ready") return null;
  return (
    <span data-testid="ready-not-delivered-flag"
      className="inline-flex items-center px-2 py-0.5 rounded-[3px] text-[11px] font-semibold tracking-wide bg-lr-clay/15 text-lr-clay border border-lr-clay/30">
      READY · NOT DELIVERED
    </span>
  );
}

export function DemandBadge({ value }) {
  if (!value) return null;
  const c = DEMAND_SAFETY[value] || DEMAND_SAFETY.INVESTIGATE;
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-[3px] text-xs font-semibold tracking-wide ${c.bg} ${c.text}`}>{c.label}</span>;
}

export function FactClassTag({ value }) {
  const map = {
    "Observed Fact": "bg-lr-olive/15 text-lr-olive",
    "Client Report": "bg-lr-clay/15 text-lr-clay",
    "External Evidence": "bg-lr-leather/15 text-lr-leather",
    Inference: "bg-lr-charcoal/10 text-lr-charcoal",
    Hypothesis: "bg-lr-rose/15 text-[#8f4a49]",
    Unknown: "bg-lr-charcoal/8 text-lr-leather",
  };
  return <span className={`inline-flex px-2 py-0.5 rounded-[3px] text-xs ${map[value] || "bg-lr-charcoal/8 text-lr-leather"}`}>{value}</span>;
}

export function Empty({ children }) {
  return <div className="text-sm text-lr-leather/80 italic py-6 text-center border border-dashed hairline rounded-[4px]">{children}</div>;
}

export function SectionCard({ title, action, children, testid }) {
  return (
    <section className="lr-card p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-serif text-xl text-lr-charcoal">{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}
